/**
 * @ngdoc directive
 * @name kpCompiledContent
 * @module portaro.directives
 *
 * @param {expression} kpCompiledContent HTML input
 *
 * @requires ng.service.$compile
 *
 * @description
 * Directive for ability to compile dynamic html content.
 * Watches "kp-compiled-content" attribute and compiles it to angular.
 *
 * @example
 * <example module="kpCompiledContentExample" name="kpCompiledContentExample" frame-no-resize="true">
    <file name="index.html">
        <main ng-controller="exampleController as ec">
            <div kp-compiled-content="ec.content"></div>
            <button ng-click="ec.change()">Change content</button>
        </main>
    </file>
    <file name="script.js">
        angular.module('kpCompiledContentExample', ['portaro.directives'])
            .controller('exampleController', class {
                constructor() {
                    this.content = '<span>{{"Hello world"}}</span>';
                }

                change() {
                    this.content = '<span>{{"Hello another world!"}}</span>';
                }
            });
    </file>
 * </example>
 */
export default class CompiledContentDirective {
    static directiveName = 'kpCompiledContent';

    restrict = 'A';
    replace = false;

    /*@ngInject*/
    constructor($compile) {
        this.$compile = $compile;
    }

    link(scope, element, attrs) {
        scope.$watch(attrs.kpCompiledContent, (html) => {
            element.html(html);
            this.$compile(element.contents())(scope);
        });
    }

}